import React, { useEffect, useState }           from 'react'
import axios                                    from 'axios'
import Box                                      from '@material-ui/core/Box'
import { CLIENT_PUBLIC_TOKEN }                  from '../config'
import Grid                                     from '@material-ui/core/Grid'
import { node_server }                          from '../Helpers'
import PilotCohortSourceReadComponent           from './PilotCohortSourceReadComponent'
import PilotCohortSourceTitleReadComponent      from './PilotCohortSourceTitleReadComponent'
import Typography                               from '@material-ui/core/Typography'

const PilotCohortSourceUpdateComponent = () => {

   const [ pilotCohortSourceTable,              setPilotCohortSourceTable        ]  =  useState({})
   const [ id,                                  setId                            ]  =  useState('')

   /* This takes a click event and records the _id of the Pilot / Cohort / Source Table from the MongoDB pilotcohortsourcetables collection */
   const handleClick = (id) => {
      setId(id)
      console.log('History Update Component got back this id from HistoryTitles', id)
   }

   return(
      <Box style={{ marginTop: '6rem', marginBottom: '1rem', padding: '2rem' }} >
         <Grid>
            <Typography variant='h4'>
               Pilot / Cohort / Source Update Page
            </Typography>
         </Grid>
         <Grid>
            { id === '' ? <PilotCohortSourceTitleReadComponent handleClick={handleClick} /> : <PilotCohortSourceReadComponent id={id} /> }
         </Grid>
      </Box>
   )
}

export default PilotCohortSourceUpdateComponent
